import { GuardedComponent } from '../components/guarded-component';
import { FastFieldReprocessQueuePage } from '../features/fast-field-reprocess-queue/fast-field-reprocess-queue.page';
import { UserPermissionName } from '../models/user-permission-name';

export const FastFieldReprocessQueueRoute = {
  path: '/reinspection-exception-report',
  name: 'Reinspection Exception Report',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.REINSPECTION_EXCEPTION_REPORT]} showPermissionError>
          <FastFieldReprocessQueuePage />
        </GuardedComponent>
      ),
    },
  ],
};
